import { BUS_AGENT_AUTO_COMPLETE_STATION_FETCH } from '../actions/fetchAutoCompleteAgent';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = [
  /* "1", "2", "3" */
];

export default function busAgentAutoCompleteReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case BUS_AGENT_AUTO_COMPLETE_STATION_FETCH:
      return action.payload;
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
